import { render, staticRenderFns } from "./NewDataCheckModal.vue?vue&type=template&id=1ff78b30&scoped=true"
import script from "./NewDataCheckModal.vue?vue&type=script&lang=js"
export * from "./NewDataCheckModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff78b30",
  null
  
)

export default component.exports